var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.996 32.006a5 5 0 00-2.985.992l-3.013-3.012a4.895 4.895 0 001-2.977 4.995 4.995 0 00-3.84-4.873 5 5 0 00-6.055 5.872A4.997 4.997 0 0029.991 31l3.006 3.012a4.995 4.995 0 002.99 7.884 5.001 5.001 0 005.545-2.781 4.995 4.995 0 00-4.536-7.109zM23.428 27.01a3.569 3.569 0 016.095-2.523A3.568 3.568 0 0127 30.579a3.571 3.571 0 01-3.57-3.57z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnections);
export default __webpack_public_path__ + "static/media/Connections.ea503a076fc5f29cfd087fccb7882023.svg";
export { ForwardRef as ReactComponent };